import {
  Drawer,
  Dialog,
  DialogContent,
  Grid,
  Icon,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useEffect } from "react";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "+", "0"];

function DialPad({ open, onClose, onSubmit, phoneNumber, setPhoneNumber }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setPhoneNumber("");
  }, [open]);

  function handleKeyPress(key) {
    setPhoneNumber((prev) => prev + key);
  }

  function handleDelete() {
    setPhoneNumber((prev) => prev.slice(0, -1));
  }

  function handleSubmit() {
    if (!phoneNumber) return;

    onSubmit(phoneNumber);
    setPhoneNumber("");
  }

  const content = (
    <MDBox p={3}>
      {isMobile && (
        <MDBox
          width="50px"
          height="5px"
          mx="auto"
          mb={0}
          borderRadius="10px"
          bgcolor="#ccc"
        />
      )}

      <MDTypography variant="h5" textAlign="center" mb={3}>
        Dial Pad
      </MDTypography>

      <MDInput
        fullWidth
        value={phoneNumber}
        placeholder="Enter phone number"
        onKeyDown={(e) => {
          const isPasteShortcut =
            (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "v";

          if (!isPasteShortcut) {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          e.preventDefault();

          const pasted = e.clipboardData
            .getData("text")
            .replace(/[^0-9*#+]/g, "");

          setPhoneNumber(pasted);
        }}
        inputProps={{
          style: {
            textAlign: "center",
            fontSize: "28px",
            letterSpacing: "2px",
          },
        }}
      />

      <MDBox mt={4}>
        <Grid container spacing={2}>
          {keys.map((key) => (
            <Grid item xs={4} key={key}>
              <IconButton
                onClick={() => handleKeyPress(key)}
                sx={{
                  width: "100%",
                  height: 75,
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: "10%",
                  fontSize: 28,
                  fontWeight: "bold",
                }}
              >
                {key}
              </IconButton>
            </Grid>
          ))}
          <Grid item xs={4}>
            <IconButton
              onClick={handleDelete}
              sx={{
                width: "100%",
                height: 75,
                border: "1px solid",
                borderColor: "grey.300",
                borderRadius: "10%",
                fontSize: 28,
                fontWeight: "bold",
              }}
            >
              <Icon>backspace</Icon>
            </IconButton>
          </Grid>
        </Grid>
      </MDBox>

      <MDBox
        mt={5}
        display="flex"
        justifyContent="space-evenly"
        alignItems="center"
      >
        {/* <IconButton
          onClick={handleDelete}
          sx={{
            width: 65,
            height: 65,
            border: "1px solid #e0e0e0",
          }}
        >
          <Icon>backspace</Icon>
        </IconButton> */}
        <IconButton
          onClick={handleSubmit}
          sx={{
            width: 75,
            height: 75,
            backgroundColor: "success.main",
            color: "#fff",
            "&:hover": {
              backgroundColor: "success.dark",
            },
          }}
        >
          <Icon>call</Icon>
        </IconButton>

        <IconButton
          onClick={onClose}
          sx={{
            width: 75,
            height: 75,
            backgroundColor: "error.main",
            color: "#fff",
            "&:hover": {
              backgroundColor: "error.dark",
            },
            border: "1px solid #e0e0e0",
          }}
        >
          <Icon>close</Icon>
        </IconButton>
      </MDBox>
    </MDBox>
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          "& .MuiDrawer-paper": {
            width: "100vw",
            maxWidth: "100vw",
            left: 0,
            right: 0,
            margin: 0,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
            height: "auto",
            overflow: "visible",
          },
        }}
      >
        {content}
      </Drawer>
    );
  }

  return (
    // <Dialog
    //   open={open}
    //   onClose={onClose}
    //   maxWidth="xs"
    //   fullWidth
    //   PaperProps={{
    //     sx: {
    //       borderRadius: 4,
    //     },
    //   }}
    // >
    //   <DialogContent>{content}</DialogContent>
    // </Dialog>
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        "& .MuiDrawer-paper": {
          position: "fixed",
          top: "0 !important",
          right: "0 !important",
          margin: "0 !important",
          width: 420,
          maxWidth: "100vw",
          height: "100vh",
          borderRadius: 0,
        },
      }}
    >
      {content}
    </Drawer>
  );
}

export default DialPad;
